module.exports = __webpack_public_path__ + "static/media/php.3849b297.jpg";